// @ts-nocheck
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/system";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { useState } from "react";

import LogoutIcon from "../../assets/images/logout.svg";
import { alertDialogAciton, logoutAction } from "../../store/actions/auth";
import "./sidebar.css";

import { Button, IconButton, Menu, MenuItem } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  ConfigurationIcon,
  ContractsIcon,
  DashboardIcon,
  EventsIcon,
  MessagesIcon,
  ProfileIcon,
  RateListIcon,
  ReportsIcon,
} from "../../assets/svgs/SVGs";
import { USER_ROLES } from "../../staticData/userRoles";
import { FRONTEND_CONFIG } from "../../utils/constants/configs";
import { isActiveRole } from "../../utils/methods/storeFunc";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
import { ExpandCircleDownRounded } from "@mui/icons-material";

const SidebarClient = ({
  toggleSideBarData = { open: true },
  setToggleSideBarData,
}) => {
  const { open } = toggleSideBarData;
  const location = useLocation();
  const navigate = useNavigate();

  // State for dropdown menus
  const [eventsMenuAnchor, setEventsMenuAnchor] = useState(null);
  const [messagesMenuAnchor, setMessagesMenuAnchor] = useState(null);
  const [configurationMenuAnchor, setConfigurationMenuAnchor] = useState(null);

  const dispatch = useDispatch();

  const auth = useSelector((store) => store.auth);
  const groupMessaging = useSelector((store) => store.groupMessaging);
  const oneOnOneMessaging = useSelector((store) => store.oneOnOneMessaging);

  // Helper component for icon with label
  const IconWithLabel = ({ Icon, label, isActive }) => (
    <Box className="main-icon-label-wrapper">
      <Box
        className={`icon-wrapper ${isActive ? "active" : ""}`}
        width={50}
        height={50}
      >
        <Box className="icon-container">
          <Icon size={40} strokeColor={isActive ? "#d175b6" : "#ffffff"} />
        </Box>
      </Box>
      <Typography className="icon-label">{label}</Typography>
    </Box>
  );

  // Helper function to render dropdown menu
  const renderDropdownMenu = (
    anchorEl,
    setAnchorEl,
    menuItems,
    menuStyles = {},
  ) => (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl) && !open}
      onClose={() => setAnchorEl(null)}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      slotProps={{
        paper: {
          onMouseLeave: () => setAnchorEl(null),
        },
      }}
      sx={{
        "& .MuiPaper-root": {
          background: "rgba(20, 20, 40, 0.95)",
          backdropFilter: "blur(10px)",
          border: "1px solid #D175B6",
          borderRadius: "8px",
          boxShadow: "0px 0px 30px 0px rgba(209, 117, 182, 0.20)",
          minWidth: "220px",
          overflow: "hidden",
          maxHeight: "none",
          marginLeft: "45px",
          marginTop: "20px",
        },
        "& .MuiMenu-list": {
          maxHeight: "none",
          overflow: "hidden",
        },
        "& .MuiMenuItem-root": {
          color: "#ffffff",
          fontSize: "16px",
          padding: "10px 16px",
          borderBottom: "1px solid rgba(209, 117, 182, 0.2)",
          "&:before": {
            content: '"•"',
            color: "#D175B6",
            marginRight: "8px",
            fontSize: "40px",
            lineHeight: ".5",
            display: "inline-block",
            marginBottom: "4px",
          },
          "&:hover": {
            background: "rgba(209, 117, 182, 0.5)",
            color: "#ffffff",
          },
          "&.active": {
            color: "#D175B6",
          },
          "&:last-child": {
            borderBottom: "none",
          },
        },
        ...menuStyles,
      }}
    >
      {(menuItems ?? []).filter(Boolean).map((item, index) => (
        <MenuItem
          key={index}
          onClick={() => {
            navigate(item?.path);
            setAnchorEl(null);
          }}
          className={item?.isActive ? "active" : ""}
        >
          {item?.label}
          {item?.badge && item.badge > 0 ? (
            <Typography
              variant="span"
              sx={{
                background: `${getCssVariableHandler({
                  variableName: "--primary-pink-rgb",
                })} !important`,
                color: `${getCssVariableHandler({
                  variableName: "--font-rgb",
                })} !important`,
                height: "20px",
                width: "20px",
                borderRadius: "50%",
                fontSize: "12px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "8px",
              }}
            >
              {item?.badge}
            </Typography>
          ) : null}
        </MenuItem>
      ))}
    </Menu>
  );

  return (
    <>
      <Box className={`sidebar-container${open ? "" : "-collapsed"}`}>
        {/* Line */}
        <Box
          sx={{
            cursor: "w-resize",
            display: { sm: "none", xl: "block" },
            position: "absolute",
            top: 0,
            right: -6,
            height: "100%",
            width: "10px",
          }}
          onClick={() =>
            setToggleSideBarData({
              ...toggleSideBarData,
              open: !open,
              priorityOpen: true,
            })
          }
        />
        {/* top button */}
        <Box
          sx={{
            display: { sm: "none", xl: "block" },
            position: "absolute",
            top: 25,
            right: -20,
            rotate: open ? "90deg" : "-90deg",
            transition: "rotate 0.3s ease-in-out",
          }}
        >
          <IconButton
            onClick={() =>
              setToggleSideBarData({
                ...toggleSideBarData,
                open: !open,
                priorityOpen: true,
              })
            }
          >
            <ExpandCircleDownRounded
              sx={{
                color: "#d175b6",
                background: "white",
                borderRadius: "50%",
              }}
            />
          </IconButton>
        </Box>
        {/* bottom button */}
        <Box
          sx={{
            display: { sm: "none", xl: "block" },
            position: "absolute",
            bottom: 75,
            right: -20,
            rotate: open ? "90deg" : "-90deg",
            transition: "rotate 0.3s ease-in-out",
          }}
        >
          <IconButton
            onClick={() =>
              setToggleSideBarData({
                ...toggleSideBarData,
                open: !open,
                priorityOpen: true,
              })
            }
          >
            <ExpandCircleDownRounded
              sx={{
                color: "#d175b6",
                background: "white",
                borderRadius: "50%",
              }}
            />
          </IconButton>
        </Box>
        <Box className="top-routes">
          <Box
            sx={{
              "& a": {
                background: "transparent",
                minHeight: "auto !important",
                padding: open ? "16px 20px" : "0px",
                color: "#ffffff",
                fontSize: "20px",
                border: "1px solid transparent",
                borderRadius: "8px",
                marginTop: "20px",
                width: "100%",
                ...(open && {
                  "&.active": {
                    border: "1px solid #D175B6",
                    color: "#D175B6",
                  },
                }),
              },
            }}
          >
            <Link
              to="/dashboard"
              className={location.pathname == "/dashboard" ? "active" : ""}
            >
              {open ? (
                "Dashboard"
              ) : (
                <IconWithLabel
                  Icon={DashboardIcon}
                  label="Dashboard"
                  isActive={location.pathname == "/dashboard"}
                />
              )}
            </Link>
          </Box>

          {open && (
            <Accordion className="accordion">
              <AccordionSummary
                expandIcon={<KeyboardArrowDownIcon sx={{ color: "#ffffff" }} />}
                aria-controls="panel1-content"
                id="panel1-header"
                className="accordion-summary"
                sx={{
                  "&.Mui-expanded": {
                    border: "1px solid #D175B6",
                    "& p": {
                      color: "#D175B6",
                    },
                    "& svg": {
                      color: "#D175B6",
                    },
                  },
                }}
              >
                <Typography>Events</Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{ overflow: "hidden" }}
                className="accordion-details"
              >
                <Box
                  sx={{
                    "& a": {
                      margin: "4px 0",
                      width: "100%",
                      color: "#ffffff",
                      padding: "8px 14px",
                      borderRadius: "4px",
                      border: "1px solid transparent",
                      position: "relative",
                      "&:before": {
                        content: '""',
                        position: "absolute",
                        width: "12px",
                        height: "81px",
                        borderRadius: "0 0 0 10px",
                        borderBottom: "1px solid #ffffff",
                        borderLeft: "1px solid #ffffff",
                        left: "-13px",
                        bottom: "13px",
                      },
                      "& span": {
                        height: "24px",
                        width: "24px",
                        background: "#FFF",
                        color: "#D175B6",
                        borderRadius: "100%",
                        marginLeft: "5px",
                        lineHeight: "24px",
                        textAlign: "center",
                        display: "inline-block",
                        position: "absolute",
                        right: "9px",
                        top: "5px",
                      },
                      "&.active": {
                        color: "#D175B6",
                        borderColor: "#D175B6",
                        "&:before": {
                          borderBottom: "1px solid #D175B6",
                          borderLeft: "1px solid #D175B6",
                          zIndex: "1",
                        },
                        "& span": {
                          background: "#D175B6",
                          color: "#fff",
                        },
                      },
                    },
                    "& a + a:before": {
                      height: "954px",
                    },
                  }}
                >
                  <Link
                    to="/event/new-requests"
                    className={
                      location.pathname === "/event/new-requests" ||
                      location.pathname.includes("/new-request/details")
                        ? "active"
                        : ""
                    }
                  >
                    New Requests
                  </Link>
                  {(!isActiveRole(USER_ROLES.CLIENT) || auth?.isApproved) && (
                    <Link
                      to="/event/estimates"
                      className={
                        location.pathname === "/event/estimates" ||
                        location.pathname.includes("/estimates/view")
                          ? "active"
                          : ""
                      }
                    >
                      Review Estimate
                    </Link>
                  )}
                  {(!isActiveRole(USER_ROLES.CLIENT) || auth?.isApproved) && (
                    <Link
                      to="/event/all-events"
                      className={
                        location.pathname === "/event/all-events" ||
                        location.pathname.includes("/event/details") ||
                        location.pathname.includes("/dashboard/details")
                          ? "active"
                          : ""
                      }
                    >
                      Approved Events
                    </Link>
                  )}
                  <Link
                    to="/event/partials"
                    className={
                      location.pathname === "/event/partials" ? "active" : ""
                    }
                  >
                    Saved Drafts
                  </Link>
                </Box>
              </AccordionDetails>
            </Accordion>
          )}

          {!open && (
            <Box
              sx={{
                background: "transparent",
                minHeight: "auto !important",
                padding: open ? "16px 20px" : "0px",
                color: "#ffffff",
                fontSize: "20px",
                border: "1px solid transparent",
                borderRadius: "8px",
                width: "100%",
                display: "flex",
                alignItems: "center",
                ...(open && {
                  "&.active": {
                    border: "1px solid #D175B6",
                    color: "#D175B6",
                  },
                }),
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Box
                  component="div"
                  sx={{
                    cursor: "pointer",
                  }}
                  onClick={(e) => setEventsMenuAnchor(e.currentTarget)}
                >
                  <IconWithLabel
                    Icon={EventsIcon}
                    label="Events"
                    isActive={
                      location.pathname === "/event/new-requests" ||
                      location.pathname.includes("/event/estimates") ||
                      location.pathname.includes("/event/all-events") ||
                      location.pathname.includes("/event/partials")
                    }
                  />
                </Box>
              </Box>

              {/* <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  borderRadius: "4px",
                  marginLeft: "6px",
                  transition: "all 0.2s ease",
                }}
              >
                <IconButton
                  size="small"
                  onClick={(e) => setEventsMenuAnchor(e.currentTarget)}
                >
                  <KeyboardArrowDownIcon
                    sx={{
                      color: "#ffffff",
                      fontSize: "30px",
                      transition: "color 0.2s ease",
                      "&:hover": {
                        color: "#D175B6",
                      },
                    }}
                  />
                </IconButton>
              </Box> */}
            </Box>
          )}

          {/* Events Menu Dropdown */}
          {renderDropdownMenu(eventsMenuAnchor, setEventsMenuAnchor, [
            {
              label: "New Requests",
              path: "/event/new-requests",
              isActive:
                location.pathname === "/event/new-requests" ||
                location.pathname.includes("/new-request/details"),
            },
            ...(!isActiveRole(USER_ROLES.CLIENT) || auth?.isApproved
              ? [
                  {
                    label: "Review Estimate",
                    path: "/event/estimates",
                    isActive:
                      location.pathname === "/event/estimates" ||
                      location.pathname.includes("/estimates/view"),
                  },
                ]
              : []),
            ...(!isActiveRole(USER_ROLES.CLIENT) || auth?.isApproved
              ? [
                  {
                    label: "Approved Events",
                    path: "/event/all-events",
                    isActive:
                      location.pathname === "/event/all-events" ||
                      location.pathname.includes("/event/details") ||
                      location.pathname.includes("/dashboard/details"),
                  },
                ]
              : []),
            {
              label: "Saved Drafts",
              path: "/event/partials",
              isActive: location.pathname === "/event/partials",
            },
          ])}

          {(!isActiveRole(USER_ROLES.CLIENT) || auth?.isApproved) && (
            <>
              {open && (
                <Accordion className="accordion">
                  <AccordionSummary
                    expandIcon={
                      <KeyboardArrowDownIcon sx={{ color: "#ffffff" }} />
                    }
                    aria-controls="panel1-content"
                    id="panel1-header"
                    className="accordion-summary"
                    sx={{
                      "&.Mui-expanded": {
                        border: "1px solid #D175B6",
                        "& p": {
                          color: "#D175B6",
                        },
                        "& svg": {
                          color: "#D175B6",
                        },
                      },
                    }}
                  >
                    <Typography>Messages</Typography>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{ overflow: "hidden" }}
                    className="accordion-details"
                  >
                    <Box
                      sx={{
                        "& a": {
                          margin: "4px 0",
                          width: "100%",
                          color: "#ffffff",
                          padding: "8px 14px",
                          borderRadius: "4px",
                          border: "1px solid transparent",
                          position: "relative",
                          "&:before": {
                            content: '""',
                            position: "absolute",
                            width: "12px",
                            height: "81px",
                            borderRadius: "0 0 0 10px",
                            borderBottom: "1px solid #ffffff",
                            borderLeft: "1px solid #ffffff",
                            left: "-13px",
                            bottom: "13px",
                          },
                          "& span": {
                            height: "24px",
                            width: "24px",
                            background: "#FFF",
                            color: "#D175B6",
                            borderRadius: "100%",
                            marginLeft: "5px",
                            lineHeight: "24px",
                            textAlign: "center",
                            display: "inline-block",
                            position: "absolute",
                            right: "9px",
                            top: "5px",
                          },
                          "&.active": {
                            color: "#D175B6",
                            borderColor: "#D175B6",
                            "&:before": {
                              borderBottom: "1px solid #D175B6",
                              borderLeft: "1px solid #D175B6",
                              zIndex: "1",
                            },
                            "& span": {
                              background: "#D175B6",
                              color: "#fff",
                            },
                          },
                        },
                        "& a + a:before": {
                          height: "954px",
                        },
                      }}
                    >
                      <Link
                        to="/event/chat"
                        className={
                          location.pathname === "/event/chat" ? "active" : ""
                        }
                      >
                        Event Chat
                        {groupMessaging?.unreadChatRoomsCount?.data
                          ?.groupCount > 0 ? (
                          <Typography
                            variant="span"
                            sx={{
                              background: `${getCssVariableHandler({
                                variableName: "--primary-pink-rgb",
                              })} !important`,
                              color: `${getCssVariableHandler({
                                variableName: "--font-rgb",
                              })} !important`,
                            }}
                          >
                            {
                              groupMessaging?.unreadChatRoomsCount?.data
                                ?.groupCount
                            }
                          </Typography>
                        ) : null}
                      </Link>
                      <Link
                        to="/event/chat/admin"
                        className={
                          location.pathname === "/event/chat/admin"
                            ? "active"
                            : ""
                        }
                      >
                        Admins
                        {oneOnOneMessaging?.unreadChatRoomsCount?.data
                          ?.oneOnOneCount > 0 ? (
                          <Typography
                            variant="span"
                            sx={{
                              background: `${getCssVariableHandler({
                                variableName: "--primary-pink-rgb",
                              })} !important`,
                              color: `${getCssVariableHandler({
                                variableName: "--font-rgb",
                              })} !important`,
                            }}
                          >
                            {
                              oneOnOneMessaging?.unreadChatRoomsCount?.data
                                ?.oneOnOneCount
                            }
                          </Typography>
                        ) : null}
                      </Link>
                    </Box>
                  </AccordionDetails>
                </Accordion>
              )}
            </>
          )}

          {!open && (
            <Box
              sx={{
                background: "transparent",
                minHeight: "auto !important",
                padding: open ? "16px 20px" : "0px",
                color: "#ffffff",
                fontSize: "20px",
                border: "1px solid transparent",
                borderRadius: "8px",
                width: "100%",
                display: "flex",
                alignItems: "center",
                ...(open && {
                  "&.active": {
                    border: "1px solid #D175B6",
                    color: "#D175B6",
                  },
                }),
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Box
                  component="div"
                  sx={{
                    cursor: "pointer",
                  }}
                  onClick={(e) => setMessagesMenuAnchor(e.currentTarget)}
                >
                  <IconWithLabel
                    Icon={MessagesIcon}
                    label="Messages"
                    isActive={location.pathname.includes("/event/chat")}
                  />
                </Box>
              </Box>

              {/* <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      borderRadius: "4px",
                      marginLeft: "6px",
                      transition: "all 0.2s ease",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={(e) => setMessagesMenuAnchor(e.currentTarget)}
                    >
                      <KeyboardArrowDownIcon
                        sx={{
                          color: "#ffffff",
                          fontSize: "30px",
                          transition: "color 0.2s ease",
                          "&:hover": {
                            color: "#D175B6",
                          },
                        }}
                      />
                    </IconButton>
                  </Box> */}
            </Box>
          )}

          {/* Messages Menu Dropdown */}
          {renderDropdownMenu(messagesMenuAnchor, setMessagesMenuAnchor, [
            {
              label: "Event Chat",
              path: "/event/chat",
              isActive: location.pathname === "/event/chat",
              badge:
                groupMessaging?.unreadChatRoomsCount?.data?.groupCount > 0
                  ? groupMessaging.unreadChatRoomsCount.data.groupCount
                  : 0,
            },
            {
              label: "Admins",
              path: "/event/chat/admin",
              isActive: location.pathname === "/event/chat/admin",
              badge:
                oneOnOneMessaging?.unreadChatRoomsCount?.data?.oneOnOneCount > 0
                  ? oneOnOneMessaging.unreadChatRoomsCount.data.oneOnOneCount
                  : 0,
            },
          ])}

          {/* contracts for client user */}
          {(!isActiveRole(USER_ROLES.CLIENT) || auth?.isApproved) &&
            FRONTEND_CONFIG.contracts && (
              <Box
                sx={{
                  "& a": {
                    background: "transparent",
                    minHeight: "auto !important",
                    padding: open ? "16px 20px" : "0px",
                    color: "#ffffff",
                    fontSize: "20px",
                    border: "1px solid transparent",
                    borderRadius: "8px",
                    width: "100%",
                    ...(open && {
                      "&.active": {
                        border: "1px solid #D175B6",
                        color: "#D175B6",
                      },
                    }),
                  },
                }}
              >
                <Link
                  to="/contracts"
                  className={
                    location.pathname == "/contracts" ||
                    location.pathname == "/contract-details"
                      ? "active"
                      : ""
                  }
                >
                  {open ? (
                    "Contracts"
                  ) : (
                    <IconWithLabel
                      Icon={ContractsIcon}
                      label="Contracts"
                      isActive={
                        location.pathname == "/contracts" ||
                        location.pathname == "/contract-details"
                      }
                    />
                  )}
                </Link>
              </Box>
            )}

          {(!isActiveRole(USER_ROLES.CLIENT) || auth?.isApproved) && (
            <Box
              sx={{
                "& a": {
                  background: "transparent",
                  minHeight: "auto !important",
                  padding: open ? "16px 20px" : "0px",
                  color: "#ffffff",
                  fontSize: "20px",
                  border: "1px solid transparent",
                  borderRadius: "8px",
                  width: "100%",
                  ...(open && {
                    "&.active": {
                      border: "1px solid #D175B6",
                      color: "#D175B6",
                    },
                  }),
                },
              }}
            >
              <Link
                to="/logs-of-event"
                className={
                  location.pathname == "/logs-of-event" ? "active" : ""
                }
              >
                {open ? (
                  "Logs Of Event"
                ) : (
                  <IconWithLabel
                    Icon={ReportsIcon}
                    label="Logs Of Event"
                    isActive={location.pathname == "/logs-of-event"}
                  />
                )}
              </Link>
            </Box>
          )}

          <Box
            sx={{
              "& a": {
                background: "transparent",
                minHeight: "auto !important",
                padding: open ? "16px 20px" : "0px",
                color: "#ffffff",
                fontSize: "20px",
                border: "1px solid transparent",
                borderRadius: "8px",
                width: "100%",
                ...(open && {
                  "&.active": {
                    border: "1px solid #D175B6",
                    color: "#D175B6",
                  },
                }),
              },
            }}
          >
            <Link
              to="/configuration/event-rates"
              className={
                location.pathname == "/configuration/event-rates"
                  ? "active"
                  : ""
              }
            >
              {open ? (
                "Event Rate List"
              ) : (
                <IconWithLabel
                  Icon={RateListIcon}
                  label="Event Rate List"
                  isActive={location.pathname == "/configuration/event-rates"}
                />
              )}
            </Link>
          </Box>

          {(!isActiveRole(USER_ROLES.CLIENT) || auth?.isApproved) && (
            <Box
              sx={{
                "& a": {
                  background: "transparent",
                  minHeight: "auto !important",
                  padding: open ? "16px 20px" : "0px",
                  color: "#ffffff",
                  fontSize: "20px",
                  border: "1px solid transparent",
                  borderRadius: "8px",
                  width: "100%",
                  ...(open && {
                    "&.active": {
                      border: "1px solid #D175B6",
                      color: "#D175B6",
                    },
                  }),
                },
              }}
            >
              <Link
                to="/profile"
                className={location.pathname == "/profile" ? "active" : ""}
              >
                {open ? (
                  "Profile"
                ) : (
                  <IconWithLabel
                    Icon={ProfileIcon}
                    label="Profile"
                    isActive={location.pathname == "/profile"}
                  />
                )}
              </Link>
            </Box>
          )}

          {(!isActiveRole(USER_ROLES.CLIENT) || auth?.isApproved) && (
            <>
              {open && (
                <Accordion className="accordion">
                  <AccordionSummary
                    expandIcon={
                      <KeyboardArrowDownIcon sx={{ color: "#ffffff" }} />
                    }
                    aria-controls="panel1-content"
                    id="panel1-header"
                    className="accordion-summary"
                    sx={{
                      "&.Mui-expanded": {
                        border: "1px solid #D175B6",
                        "& p": {
                          color: "#D175B6",
                        },
                        "& svg": {
                          color: "#D175B6",
                        },
                      },
                    }}
                  >
                    <Typography>Miscellaneous</Typography>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{ overflow: "hidden" }}
                    className="accordion-details"
                  >
                    <Box
                      sx={{
                        "& a": {
                          margin: "4px 0",
                          width: "100%",
                          color: "#ffffff",
                          padding: "8px 14px",
                          borderRadius: "4px",
                          border: "1px solid transparent",
                          position: "relative",
                          "&:before": {
                            content: '""',
                            position: "absolute",
                            width: "12px",
                            height: "81px",
                            borderRadius: "0 0 0 10px",
                            borderBottom: "1px solid #ffffff",
                            borderLeft: "1px solid #ffffff",
                            left: "-13px",
                            bottom: "13px",
                          },
                          "& span": {
                            height: "24px",
                            width: "24px",
                            background: "#FFF",
                            color: "#D175B6",
                            borderRadius: "100%",
                            marginLeft: "5px",
                            lineHeight: "24px",
                            textAlign: "center",
                            display: "inline-block",
                            position: "absolute",
                            right: "9px",
                            top: "5px",
                          },
                          "&.active": {
                            color: "#D175B6",
                            borderColor: "#D175B6",
                            "&:before": {
                              borderBottom: "1px solid #D175B6",
                              borderLeft: "1px solid #D175B6",
                              zIndex: "1",
                            },
                            "& span": {
                              background: "#D175B6",
                              color: "#fff",
                            },
                          },
                        },
                        "& a + a:before": {
                          height: "954px",
                        },
                      }}
                    >
                      <Link
                        to="/configuration/tutorial-video"
                        className={
                          location.pathname == "/configuration/tutorial-video"
                            ? "active"
                            : ""
                        }
                      >
                        Tutorial Video
                      </Link>

                      {/* FIX #3: use isActiveRole, not isUserRole. isUserRole is an
                          OR over ALL approved roles, so a multi-role account that
                          is also superAdmin saw "System Notifications" while
                          active as Client — and the route isn't registered under
                          the Client layout, so it 404'd. The active role here is
                          always client (this is SideBarClient), so this item is
                          correctly hidden. */}
                      {isActiveRole(USER_ROLES.SUPERADMIN) ? (
                        <Link
                          to="/configuration/system-notifications"
                          className={
                            location.pathname ==
                            "/configuration/system-notifications"
                              ? "active"
                              : ""
                          }
                        >
                          System Notifications
                        </Link>
                      ) : null}
                    </Box>
                  </AccordionDetails>
                </Accordion>
              )}

              {!open && (
                <Box
                  sx={{
                    background: "transparent",
                    minHeight: "auto !important",
                    padding: open ? "16px 20px" : "0px",
                    color: "#ffffff",
                    fontSize: "20px",
                    border: "1px solid transparent",
                    borderRadius: "8px",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    ...(open && {
                      "&.active": {
                        border: "1px solid #D175B6",
                        color: "#D175B6",
                      },
                    }),
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Box
                      component="div"
                      sx={{
                        cursor: "pointer",
                      }}
                      onClick={(e) =>
                        setConfigurationMenuAnchor(e.currentTarget)
                      }
                    >
                      <IconWithLabel
                        Icon={ConfigurationIcon}
                        label="Miscellaneous"
                        isActive={location.pathname.includes("/configuration/")}
                      />
                    </Box>
                  </Box>

                  {/* <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      borderRadius: "4px",
                      marginLeft: "6px",
                      transition: "all 0.2s ease",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={(e) =>
                        setConfigurationMenuAnchor(e.currentTarget)
                      }
                    >
                      <KeyboardArrowDownIcon
                        sx={{
                          color: "#ffffff",
                          fontSize: "30px",
                          transition: "color 0.2s ease",
                          "&:hover": {
                            color: "#D175B6",
                          },
                        }}
                      />
                    </IconButton>
                  </Box> */}
                </Box>
              )}

              {/* Configuration Menu Dropdown */}
              {renderDropdownMenu(
                configurationMenuAnchor,
                setConfigurationMenuAnchor,
                [
                  {
                    label: "Tutorial Video",
                    path: "/configuration/tutorial-video",
                    isActive:
                      location.pathname == "/configuration/tutorial-video",
                  },
                  // FIX #3: collapsed-sidebar variant of the same item — use
                  // isActiveRole so it never appears for the Client active role
                  // (route not registered under the Client layout → 404).
                  ...(isActiveRole(USER_ROLES.SUPERADMIN)
                    ? [
                        {
                          label: "System Notifications",
                          path: "/configuration/system-notifications",
                          isActive:
                            location.pathname ==
                            "/configuration/system-notifications",
                        },
                      ]
                    : []),
                ],
              )}
            </>
          )}
        </Box>

        {open ? (
          <Box>
            <Button
              sx={{
                background: "#000000",
                minHeight: "auto !important",
                padding: "16px 20px",
                color: "#ffffff",
                fontSize: "16px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                boxShadow: "0px 0px 30px 0px rgba(209, 117, 182, 0.20)",
                justifyContent: "center",
                cursor: "pointer",
                width: "100%",
                "& img": {
                  marginRight: "15px",
                },
                "&:hover": {
                  background: "#000000",
                  minHeight: "auto !important",
                  padding: "16px 20px",
                  color: "#ffffff",
                  fontSize: "16px",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  boxShadow: "0px 0px 30px 0px rgba(209, 117, 182, 0.20)",
                  justifyContent: "center",
                  cursor: "pointer",
                  width: "100%",
                  "& img": {
                    marginRight: "15px",
                  },
                },
              }}
              onClick={(e) => {
                dispatch(
                  alertDialogAciton({
                    open: true,
                    title: "Confirm Logout",
                    message: "Are you sure, you want to logout?",
                    onOk: () => {
                      dispatch(logoutAction({}));
                      navigate("/login");
                    },
                    okLabel: "Logout",
                    closeLabel: "Stay Logged In",
                  }),
                );
              }}
            >
              <img src={LogoutIcon} />
              Logout
            </Button>
          </Box>
        ) : (
          <IconButton
            onClick={(e) => {
              dispatch(logoutAction({}));
              navigate("/login");
            }}
          >
            <img src={LogoutIcon} className="logout-button-icon" />
          </IconButton>
        )}
      </Box>
    </>
  );
};

export default SidebarClient;